import { Tile as TileLayer } from 'ol/layer';
import ImageTile from 'ol/source/ImageTile';
import { LoaderOptions } from 'ol/source/DataTile';

const apiBaseUrl = (window as any)?._env_?.REACT_APP_API_BASE_URL
  ?? process.env.REACT_APP_API_BASE_URL
  ?? '';

const getGameCodeFromUrl = (): string => {
  const match = window.location.pathname.match(/\/games\/([^/]+)/);
  return match?.[1] ?? '';
};

export const createGoogleLayer = (): TileLayer => {
  return new TileLayer({
    source: new ImageTile({
      crossOrigin: 'anonymous',
      maxZoom: 20,
      wrapX: false,
      loader: (z, x, y, loaderOptions: LoaderOptions) => {
        const gameCode = getGameCodeFromUrl();
        return fetch(
          `${apiBaseUrl}/api/map/googleTile?zoom=${z}&x=${x}&y=${y}`,
          {
            headers: {
              'X-Game-Code': gameCode
            },
            signal: loaderOptions?.signal
          }
        )
          .then(response => {
            if (!response.ok) {
              throw new Error(`Google tile request failed: ${response.status}`);
            }
            return response.blob();
          })
          .then(blob => {
            return new Promise<HTMLImageElement>((resolve, reject) => {
              const img = new Image();
              const objectUrl = URL.createObjectURL(blob);
              img.onload = () => {
                URL.revokeObjectURL(objectUrl); // free memory after load
                resolve(img);
              };
              img.onerror = (e) => {
                URL.revokeObjectURL(objectUrl); // free memory on error
                reject(e);
              };
              img.src = objectUrl;
            });
          });
      }
    })
  });
};